
  import React from "react"
  import Component from "/Users/juahernandez/Developer/static.univision.com/especial/deportes/uefa-champions-league-src/src/layouts/internal.js"
  import data from "/Users/juahernandez/Developer/static.univision.com/especial/deportes/uefa-champions-league-src/.cache/json/layout-internal.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/internal.js